import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import FigureCaption from "../../components/LdsFigureCaption";
import Chart from "../../assets/module-1/1-3-3-chart.svg";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_3_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.3.3 How to Use Amyvid: Timing
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5 row">
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <FigureCaption
                  noCollapse={true}
                  className="figcaption-no-border mt-0"
                  textContent={
                    <p className="text-center p-3">
                      The graph shows the time-activity curve for Amyvid (the
                      standard uptake volume [SUV] ratio relative to the
                      cerebellum over time) in the brains of patients with AD
                      and healthy controls.<sup>2</sup>
                    </p>
                  }
                >
                  <LdsImage
                    src={Chart}
                    alt="Line graph titled 'Mean Time-Activity Curve' showing the SUV ratio relative to the cerebellum over time for Alzheimer's disease patients and healthy controls. The Alzheimer's disease curve is higher and increases more rapidly than the healthy control curve over 90 minutes"
                    style={{ maxWidth: "700px" }}
                    className=""
                  />
                </FigureCaption>
              </div>
              <div className="col-sm-12 col-md-5">
                <p>
                  Time-activity curves for Amyvid in the brains of subjects with
                  positive scans show continual signal increases from time 0-30
                  minutes post administration, with stable values thereafter, up
                  to at least 90 minutes post injection.<sup>1</sup>
                </p>
                <p>
                  Amyvid has up to 60 minutes of stable image contrast following
                  a 30-minute uptake, which provides flexibility for scheduling
                  and technical delays, and offers an opportunity for a repeat
                  scan, if necessary.<sup>2</sup>
                </p>
              </div>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
              <li>Data on file, Lilly Research Laboratories: AMY20121001R</li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_3_3;
